import { InputText } from "primereact/inputtext"
import styles from "../../../styles/CoordinationBoards.module.css"
import {
  renderRequireFieldErrorMessage,
  requiredFieldIsMissing,
} from "./Utils"

const TextField = ({
  label,
  value,
  valueName,
  onChange,
  disabled,
  required,
  showRequiredFieldMge,
  style,
  placeholder
}) => {
  return (
    <div className={styles.field} style={style ? style : { width: "100%" }}>
      <label className={`${styles.label} ${required ? styles.required : ""}`}>
        {label}
      </label>
      <InputText
        value={value}
        style={{ width: "100%" }}
        disabled={disabled}
        onChange={onChange}
        className={`p-inputtext-md ${showRequiredFieldMge && requiredFieldIsMissing(value)
          ? styles.invalid
          : ""
          }`}
        name={valueName}
        placeholder={placeholder}
      />
      {showRequiredFieldMge &&
        renderRequireFieldErrorMessage(value, `${label} is required`)}
    </div>
  )
}
export default TextField
